<template>
  <div id="app">
    <nav-bar />
    <router-view/>
  </div>
</template>
<script>
import navBar from '@/components/navBar.vue'

export default {
  name: 'home',
  components: {
    'nav-bar': navBar
  }
}
</script>

<style lang="sass" src="bulma"></style>
<style lang="css" src="@fortawesome/fontawesome-free/css/all.css"></style>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  touch-action: pan-y; // No double tap to zoom etc
  overscroll-behavior: contain; // No pull down to refresh
}
</style>
